/**
 * Implement methods to de/activate a MenuItem on a TVDecoder.
 *
 * Depends on:
 *
 *   this.busy (Boolean): Optional
 *   this.menuItemEntries (Array[MenuItem]): Optional
 */
export default {
  methods: {
    activateMenuItemOnStores(menuItem, stores, callback = null) {
      this.busy = true;

      const storeIds = stores.map((store) => store.id);
      const promises = [];

      promises.push(
        this.$api
          .activateMenuItemOnStores(menuItem.id, storeIds)
          .then((response) => {
            // Frontend update.
            const newEntries = response.data;
            for (const newEntry of newEntries) {
              if (callback) {
                callback(newEntry);
              }
              if (this.menuItemEntries !== undefined) {
                this.menuItemEntries.push(newEntry);
              }
            }
          })
      );

      return Promise.all(promises).finally(() => {
        this.busy = false;
      });
    },
    deactivateMenuItemOnStores(
      menuItem,
      stores,
      callback = null,
      toggleBusy = false,
      until = null
    ) {
      this.busy = toggleBusy;

      const storeIds = stores.map((store) => store.id);
      const promises = [];

      promises.push(
        this.$api
          .deactivateMenuItemOnStores(menuItem.id, storeIds, until)
          .then((response) => {
            // Frontend update.
            const deletedEntryIds = response.data;
            for (const deletedEntryId of deletedEntryIds) {
              if (callback) {
                callback(deletedEntryId);
              }
              if (this.menuItemEntries !== undefined) {
                this.menuItemEntries = this.menuItemEntries.filter(
                  (entry) => entry.id != deletedEntryId
                );
              }
            }
          })
      );

      return Promise.all(promises).finally(() => {
        this.busy = false;
      });
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/activateMenuItem.js